export default {
	welcome: "Welcome to ORI",
	subtitle: "Management System for Umbanda Temples",
	description: "A complete platform to manage your temple's spiritual life, from tracking mediumistic journey to organizing rituals and spiritual chains.",
	trust: {
		secure: "Secure and Reliable",
		secureDesc: "Data protected with encryption",
		respectful: "Respectful",
		respectfulDesc: "Developed with care and respect for traditions",
		intuitive: "Intuitive",
		intuitiveDesc: "Simple and easy-to-use interface",
	},
	tagline: "Built from one child of Axé to another child of Axé",
	howItWorks: {
		title: "How It Works",
		subtitle: "In three simple steps, your temple will be organized",
		step1: {
			title: "Register Your Temple",
			description: "Create your account, set up your temple name and invite users",
		},
		step2: {
			title: "Configure Your House",
			description: "Add mediums, their guides, attendance types and rituals",
		},
		step3: {
			title: "Manage with Ease",
			description: "Control rituals, attendance, finances and track the mediumistic journey",
		},
	},
	faq: {
		title: "Frequently Asked Questions",
		q1: "Does ORI have paid plans?",
		a1: "We will soon have plans with advanced features. Stay tuned for updates on our website.",
		q2: "Is my data secure?",
		a2: "Absolutely. We use encryption, temple isolation (RLS) and automatic backups. No temple can access another's data.",
		q3: "Does it work on mobile?",
		a3: "We are working on mobile compatibility. On tablets, the system works perfectly.",
		q4: "Can I call tickets on a TV?",
		a4: "Yes, ORI has an Android app for Google TV or Fire TV where you can call tickets from a tablet or phone, plus display custom messages and videos for attendees.",
		q5: "Can I use my physical tickets? Or does it print tickets?",
		a5: "You can use your physical tickets, or use the option to print via a thermal printer. The cost per printed ticket is less than 1 cent. Plus, the ticket has more info and can include personalized messages for each attendee.",
		q6: "Can I use it in more than one temple?",
		a6: "Yes. A single account can be linked to multiple temples with different roles. Each temple has its own independent plan and subscription.",
		q7: "Does ORI integrate with a bank to receive payments?",
		a7: "Yes! Through Mercado Pago, you connect your temple's account and charge dues and contributions via PIX or credit card — with a payment link, automatic reconciliation, and recurring automatic debit. The fees are Mercado Pago's own: PIX 0.99% per transaction (instant settlement) and credit card around 4.98% (dropping to ~3.98% after 30 days), including recurring charges. ORI charges nothing extra — the money goes straight into the temple's account.",
	},
	manual: {
		link: "Manual",
	},
	nav: {
		screens: "Screens",
		faq: "FAQ",
		contact: "Contact",
		plans: "Plans",
	},
	contact: {
		title: "Contact Us",
		subtitle: "Have a question or suggestion? Send us a message!",
		name: "Name",
		subject: "Subject",
		message: "Message",
		email: "Email",
		phone: "Phone",
		referralSource: "How did you hear about ORI?",
		send: "Send Message",
		success: "Message sent successfully! We'll get back to you soon.",
		errors: {
			message: "Message is required",
			email: "Email is required",
			generic: "Error sending message. Please try again.",
		},
		referrals: {
			google: "Google / Internet search",
			socialMedia: "Social media",
			friend: "Friend recommendation",
			event: "Event / Conference",
			other: "Other",
		},
	},
	cta: {
		login: "Login to System",
		dashboard: "Go to Dashboard",
		getStarted: "Get Started",
		learnMore: "Learn More",
	},
	pricing: {
		noCardRequired: "No credit card required during trial period",
	},
	testimonials: {
		title: "Trust and Spiritual Organization",
		subtitle: "Developed with respect and understanding of Umbanda traditions",
	},
};
